import * as React from "react"
export const ZipCodeIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g clipPath='url(#clip0_381_69)'>
      <path
        d='M2.29174 4.16667H17.7084C18.2651 4.16667 18.7692 4.37417 19.1667 4.705V3.95833C19.1667 2.465 17.9517 1.25 16.4584 1.25H3.54174C2.0484 1.25 0.833405 2.465 0.833405 3.95833V4.705C1.2309 4.37417 1.73507 4.16667 2.29174 4.16667Z'
        fill='currentColor'
      />
      <path
        d='M17.7083 5.8335H2.29167C1.0275 5.8335 0 6.861 0 8.12516V16.8752C0 18.1393 1.0275 19.1668 2.29167 19.1668H17.7083C18.9725 19.1668 20 18.1393 20 16.8752V8.12516C20 6.861 18.9725 5.8335 17.7083 5.8335ZM3.33333 11.6668H6.66667C7.1275 11.6668 7.5 12.0402 7.5 12.5002C7.5 12.9602 7.1275 13.3335 6.66667 13.3335H3.33333C2.8725 13.3335 2.5 12.9602 2.5 12.5002C2.5 12.0402 2.8725 11.6668 3.33333 11.6668ZM10 16.6668H3.33333C2.8725 16.6668 2.5 16.2935 2.5 15.8335C2.5 15.3735 2.8725 15.0002 3.33333 15.0002H10C10.4608 15.0002 10.8333 15.3735 10.8333 15.8335C10.8333 16.2935 10.4608 16.6668 10 16.6668ZM17.5 12.7085C17.5 13.0535 17.22 13.3335 16.875 13.3335H13.125C12.78 13.3335 12.5 13.0535 12.5 12.7085V8.9585C12.5 8.6135 12.78 8.3335 13.125 8.3335H16.875C17.22 8.3335 17.5 8.6135 17.5 8.9585V12.7085Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_381_69'>
        <rect width={20} height={20} fill='white' />
      </clipPath>
    </defs>
  </svg>
)
